<div class="animation">
  <div class="animation-wrapper" [class]="classExpression">
    <img src="../../../assets/images/circle_fridge.svg" alt="" />
    <img class="hand" src="../../../assets/images/hand.svg" alt="" />
    <img class="cola" src="../../../assets/images/cola.svg" alt="" />
  </div>
</div>
